import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles, Link } from '@material-ui/core';
import { CloudOff, PrintDisabled } from '@material-ui/icons';

import StatusMessage from 'components/StatusMessage';
import { REDSHELF_SOLVE_LINK } from 'constants';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {},
    /* Print Unavailable styles */
    statusMessage: {
      padding: theme.spacing(2, 3),

      lineHeight: theme.typography.pxToRem(24),
      letterSpacing: theme.typography.pxToRem(0.15) + '!important',
    },
    solveLink: {
      color: theme.palette.primary.main + '!important',
    },
  };
});

const getCurrentMessage = (printEnabled, isOffline, classes) => {
  if (!printEnabled) {
    return {
      icon: <PrintDisabled />,
      title: 'Print Unavailable',
      body: (
        <>
          Print is not available for this material.
          <br />
          Learn more about print capabilities on our{' '}
          <Link
            className={classes.solveLink}
            href={REDSHELF_SOLVE_LINK}
            underline="always"
            target="_blank"
            rel="noreferrer"
          >
            RedShelf Solve page
          </Link>
          .
        </>
      ),
    };
  }

  if (isOffline) {
    return {
      icon: <CloudOff />,
      title: 'You’re Offline',
      body: 'Your network connection is unavailable. While offline, you will not be able to print the contents of this material. ',
    };
  }

  return {};
};

const PrintUnavailableMessage = ({ isOffline, printEnabled, ...props }) => {
  const classes = useStyles();

  const { icon, title, body } = getCurrentMessage(
    printEnabled,
    isOffline,
    classes,
  );

  return (
    <StatusMessage
      className={classes.statusMessage}
      icon={icon}
      title={title}
      {...props}
    >
      {body}
    </StatusMessage>
  );
};

PrintUnavailableMessage.propTypes = {
  isOffline: PropTypes.bool,
  printEnabled: PropTypes.bool,
};

export default PrintUnavailableMessage;
